module.exports = __webpack_public_path__ + "static/media/silica_fert.db741aea.png";